import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const jiraHomeRoute: InvariantJiraRoute = {
	name: 'for-you',
	path: '/jira/for-you',
};
